import styled from 'styled-components';
import { TablePagination as MUITablePagination, TablePaginationProps } from '@mui/material';

type ITablePaginationProps = {
  component: string;
} & TablePaginationProps;

export const TablePagination = styled(MUITablePagination)<ITablePaginationProps>`
  &&& {
    font-size: 12px;
    border-bottom: none;
  }

  p {
    font-size: inherit;
  }

  div:nth-of-type(2) {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }

  & .MuiTablePagination-spacer {
    display: none;
  }
`;

TablePagination.defaultProps = {
  size: 'small',
};
